/**
 * Browser compatibility helper for Webpack build
 * Provides safe access to browser globals during build time
 */

// Check if we're in a browser environment
export const isBrowser = typeof window !== 'undefined';

// Safe window reference
export const safeWindow = isBrowser ? window : {
    addEventListener: () => {},
    removeEventListener: () => {},
    localStorage: {
        getItem: () => null,
        setItem: () => {},
        removeItem: () => {}
    },
    sessionStorage: {
        getItem: () => null,
        setItem: () => {},
        removeItem: () => {}
    },
    location: {
        href: '',
        search: '',
        pathname: ''
    },
    navigator: {
        userAgent: '',
        platform: ''
    },
    print: () => {},
    confirm: () => false,
    alert: () => {},
    scrollTo: () => {},
    focus: () => {},
    blur: () => {}
};

// Safe document reference
export const safeDocument = typeof document !== 'undefined' ? document : {
    activeElement: null,
    getElementById: () => null,
    querySelector: () => null,
    querySelectorAll: () => [],
    addEventListener: () => {},
    removeEventListener: () => {},
    height: 0
};

// Safe jQuery reference
export const safeJQuery = isBrowser && typeof $ !== 'undefined' ? $ : () => ({
    scrollTop: () => {},
    find: () => ({
        length: 0
    }),
    height: () => 0
});

// Global variable checks
export const globals = {
    ecareEnv: typeof ecareEnv !== 'undefined' ? ecareEnv : 'dev',
    ecareAnalytics: typeof ecareAnalytics !== 'undefined' ? ecareAnalytics : false,
    ecvConfig: typeof ecvConfig !== 'undefined' ? ecvConfig : '',
    ecvStorage: typeof ecvStorage !== 'undefined' ? ecvStorage : '',
    ecvZoomConfig: typeof ecvZoomConfig !== 'undefined' ? ecvZoomConfig : ''
};

// Navigator compatibility
export const isIE11 = isBrowser && safeWindow.navigator && safeWindow.navigator.userAgent.indexOf('Trident') > -1;
export const isIPad = isBrowser && (safeWindow.navigator.userAgent.match(/(iPad)/) || 
    (safeWindow.navigator.platform === 'MacIntel' && safeWindow.navigator.maxTouchPoints > 1));
